import React from 'react';
import { Card } from './ui/Card';
import { CalendarClock } from 'lucide-react';
export function FollowUpCard({
  highlighted
}: {
  highlighted?: boolean;
}) {
  return <Card delay={0.7} highlighted={highlighted} data-id="element-134">
      <div className="flex items-center justify-between mb-6" data-id="element-135">
        <h2 className="text-2xl text-navy flex items-center gap-2" data-id="element-136">
          <CalendarClock className="text-crimson" size={24} data-id="element-137" />
          Follow Up
        </h2>
      </div>

      <div className="mb-4" data-id="element-138">
        <span className="text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-139">
          Suggested Date
        </span>
        <p className="text-navy font-serif text-lg mt-1" data-id="element-140">02/24/2025</p>
      </div>

      <ul className="space-y-3 border-t border-warmgray pt-4" data-id="element-141">
        <li className="flex items-start gap-3" data-id="element-142">
          <div className="mt-1 w-4 h-4 rounded border border-gray-400 flex-shrink-0 bg-white" data-id="element-143" />
          <span className="text-sm text-gray-800" data-id="element-144">
            Send a follow-up email with portal link.
          </span>
        </li>
        <li className="flex items-start gap-3" data-id="element-145">
          <div className="mt-1 w-4 h-4 rounded border border-gray-400 flex-shrink-0 bg-white" data-id="element-146" />
          <span className="text-sm text-gray-800" data-id="element-147">
            Call the client to discuss portal completion.
          </span>
        </li>
        <li className="flex items-start gap-3" data-id="element-148">
          <div className="mt-1 w-4 h-4 rounded border border-gray-400 flex-shrink-0 bg-white" data-id="element-149" />
          <span className="text-sm text-gray-800" data-id="element-150">
            Schedule a call to review loan options.
          </span>
        </li>
      </ul>
    </Card>;
}